<template>
    <div class="flex flex-col px-5 py-4 gap-3 rounded-xl bg-gray-100">
        <p v-if="jobTitle" class="text-gray-900 text-sm font-medium">{{ jobTitle }}</p>
        <p v-if="jobDescription" class="text-gray-500 text-xs">{{ jobDescription }}</p>
        <GgmsProgressBar
            :isProgressNumberVisible="true"
            :progress="jobProgress"
            barColor="bg-primary-color-500"
            progressSuffix="%"
        />
    </div>
</template>

<script lang="ts" setup>
import GgmsProgressBar from "@/components/GgmsProgressBar.vue"

interface Props {
    jobTitle?: string
    jobDescription?: string
    jobProgress: number
}

defineProps<Props>()
</script>
